export abstract class EccomerceApiRoutes {

  public static readonly CATEGORY_PRODUCTS = 'catalog/store/%s/%s/category/%s/product?showProducts=false&languageId=%s';

  public static readonly PRODUCT_ARRAY = 'catalog/store/%s/%s/productsArray?%s=%s&languageId=%s';

}
